/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:49450608-8bca-4356-b7ab-8d0eeccd1469",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_VCIVul9cC",
    "aws_user_pools_web_client_id": "21hma2bacfardt56kuh5a6ke7g",
    "oauth": {},
    "aws_content_delivery_bucket": "alturagroup.com-prod",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "https://d16dy2nkhktvtw.cloudfront.net",
    "aws_cloud_logic_custom": [
        {
            "name": "api23b65950",
            "endpoint": "https://yiypbf79o2.execute-api.us-east-1.amazonaws.com/prod",
            "region": "us-east-1"
        }
    ]
};


export default awsmobile;
